import React, { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Typography } from '@saucelabs/ds-typography';
import { Toggle } from '@saucelabs/ds-inputs';
import { constants as appStorageConstants } from '@saucelabs/sl-module-app-storage';

import SwitchInfoTooltip from './SwitchInfoTooltip';
import { selectors as groupsSelectors } from '../../group';
import selectors from '../selectors';
import operations from '../operations';

const {
  ANDROID,
  IOS,
} = appStorageConstants.APP_STORAGE_KIND;

const TOOLTIP_ANDROID = 'Enables you to automatically populate the screenlock and PIN on the device.';
const TOOLTIP_IOS = 'Enables you to automatically populate the passcode on the device. Please note that the device allocation time is slightly increased with this capability.';
const TOOLTIP_OTHER = 'n/a';

const Passcode: React.FC = () => {
  const dispatch = useDispatch<ReduxDispatcher>();
  const settings = useSelector(groupsSelectors.currentGroupSettingsSelector);
  const currentGroup = useSelector(groupsSelectors.currentGroupSelector);
  const isLoading = useSelector(selectors.isSettingsLoadingSelector);
  const kind = useSelector(groupsSelectors.currentGroupKindSelector);
  // TODO: setup_device_lock is now available in both iOS and Android settings,
  // but the curent API definition is not up-to-date.
  // The API definition in sl-module-app-storage needs to be updated!
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const currentValue = settings?.setup_device_lock ?? false;

  const changeHandler = useCallback((newValue: boolean) => {
    if (currentGroup) {
      void dispatch(operations.updateSettings({
        groupId: currentGroup.id,
        originalValues: {
          setup_device_lock: currentValue,
        },
        settingsName: 'device passcode',
        updatedValues: {
          setup_device_lock: newValue,
        },
      }));
    }
  }, [currentGroup, dispatch, currentValue]);

  const tooltipText = useMemo(() => {
    if (kind === ANDROID) {
      return TOOLTIP_ANDROID;
    }
    if (kind === IOS) {
      return TOOLTIP_IOS;
    }
    return TOOLTIP_OTHER;
  }, [kind]);

  return (
    <div className="flex justify-between">
      <div className="flex">
        <Typography className="text-high-emphasis font-semibold">
          Device Passcode
        </Typography>
        <SwitchInfoTooltip
          title={tooltipText}
        />
      </div>
      <Toggle
        isDisabled={isLoading}
        isSelected={currentValue}
        onChange={changeHandler}
      />
    </div>
  );
};

export default Passcode;
